import { SET_CURRENTLY_VIEWING } from '../../../actions/actionTypes'

export function currentlyViewing(state = 0, action) {
  switch (action.type) {
    case SET_CURRENTLY_VIEWING:
      return action.currentlyViewing
    default:
      return state
  }
}
